import { render, staticRenderFns } from "./EdicionCertificadosPantalla.vue?vue&type=template&id=1c062c2a&"
import script from "./EdicionCertificadosPantalla.vue?vue&type=script&lang=ts&"
export * from "./EdicionCertificadosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1c062c2a', component.options)
    } else {
      api.reload('1c062c2a', component.options)
    }
    module.hot.accept("./EdicionCertificadosPantalla.vue?vue&type=template&id=1c062c2a&", function () {
      api.rerender('1c062c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/EdicionCertificados/EdicionCertificadosPantalla.vue"
export default component.exports